import { withRouter } from 'react-router-dom';

import PutOnHoldNoDepositButton from './PutOnHoldNoDepositButton';

export default withRouter(PutOnHoldNoDepositButton);
